export default "__VITE_ASSET__BFV0hoD6__"